import * as React from "react";
import { useTranslation } from "react-i18next";
import { DeleteMenuItem } from "components/bootstrap";
import useDeleteFailedSnapshotMutation from "data-tiering/hooks/useDeleteFailedSnapshotMutation";
const DeleteFailedSnapshotMenuItem = ({ eventKey, indexSetId }) => {
  const { t } = useTranslation("enterprise_data_tiering");
  const { deleteFailedSnapshot } = useDeleteFailedSnapshotMutation(indexSetId);
  const onConfirmDelete = () => {
    deleteFailedSnapshot();
  };
  const onDeleteSnapshot = () => {
    if (
      // eslint-disable-next-line no-alert
      window.confirm(t("delete_failed_snapshot.confirm"))
    ) {
      onConfirmDelete();
    }
  };
  return /* @__PURE__ */ React.createElement(DeleteMenuItem, { eventKey, onClick: onDeleteSnapshot }, t("delete_failed_snapshot.menu_item"));
};
export default DeleteFailedSnapshotMenuItem;
